<div class="container mx-auto">
  <div class="max-w-full mx-auto">
    <!-- Header Section -->
    <div
      class="flex flex-wrap items-center justify-between mb-6 pb-4 border-b border-base-300"
    >
      <div class="flex-1">
        <h2
          class="text-2xl font-bold text-base-content flex items-center gap-2"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 14l6-6m-5.5.5h.01m4.99 5h.01M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16l3.5-2 3.5 2 3.5-2 3.5 2z"
            />
          </svg>
          My Invoices
        </h2>
        <p class="text-sm text-base-content/60 mt-1">
          Track and manage your payment invoices
        </p>
      </div>
    </div>

    <div class="flex flex-wrap">
      <div class="w-full">
        <div
          class="daisy-card bg-base-100 border border-base-300 shadow-sm overflow-hidden"
        >
          <div class="daisy-card-body p-0">
            <div class="overflow-x-auto max-h-[600px] min-h-[300px]">
              <table
                class="daisy-table daisy-table-sm md:daisy-table-md daisy-table-pin-rows"
              >
                <thead class="bg-base-200">
                  <tr>
                    <th class="font-semibold">Invoice No</th>
                    <th class="font-semibold">Status</th>
                    <th class="font-semibold">Total Amount</th>
                    <th class="font-semibold">Payment Due On</th>
                    <th class="font-semibold">Due Amount</th>
                    <th class="font-semibold">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  @for (invoice of invoices; track invoice) {
                  <tr class="hover:bg-base-200 transition-colors">
                    <td>
                      <div class="flex items-center gap-2">
                        <div class="daisy-avatar daisy-placeholder">
                          <div
                            class="bg-secondary/10 text-secondary rounded-lg w-8 h-8"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              class="h-4 w-4"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                              />
                            </svg>
                          </div>
                        </div>
                        <span class="font-medium">{{
                          invoice.invoiceNumber
                        }}</span>
                      </div>
                    </td>
                    <td>
                      <span
                        class="daisy-badge"
                        [class.daisy-badge-success]="invoice.status === 'PAID'"
                        [class.daisy-badge-warning]="
                          invoice.status === 'PROCESSING' ||
                          invoice.status === 'PARTIALY_PAID'
                        "
                        [class.daisy-badge-error]="
                          invoice.status === 'OVERDUE' ||
                          invoice.status === 'CANCELLED'
                        "
                      >
                        {{ invoice.status }}
                      </span>
                    </td>
                    <td>
                      <span class="font-medium"
                        >{{ invoice.amount }} {{ invoice.currency }}</span
                      >
                    </td>
                    <td>
                      <div class="flex items-center gap-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="h-4 w-4 text-base-content/60"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                          />
                        </svg>
                        {{ invoice.dueDate | date: 'MMM d, y' }}
                      </div>
                    </td>
                    <td>
                      <span class="font-medium text-warning">
                        {{ calculatePayable(invoice.amount, invoice.payments) }}
                        {{ invoice.currency }}
                      </span>
                    </td>
                    <td>
                      <div class="flex gap-2">
                        <button
                          [disabled]="isPayButtonDisabled(invoice.status)"
                          (click)="payInvoice(invoice._id)"
                          type="button"
                          class="daisy-btn daisy-btn-sm daisy-btn-primary gap-2"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="h-4 w-4"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
                            />
                          </svg>
                          Pay Now
                        </button>
                        <div class="daisy-dropdown daisy-dropdown-end">
                          <button
                            class="daisy-btn daisy-btn-sm daisy-btn-ghost"
                            tabindex="0"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              class="h-5 w-5"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"
                              />
                            </svg>
                          </button>
                          <ul
                            tabindex="0"
                            class="daisy-dropdown-content daisy-menu bg-base-100 rounded-box z-50 w-52 p-2 shadow-lg border border-base-300"
                          >
                            @if (invoice.payments.length !== 0) {
                            <li>
                              <button
                                (click)="toggleInvoiceRow(invoice._id)"
                                type="button"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  class="h-4 w-4"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke="currentColor"
                                >
                                  <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                                  />
                                </svg>
                                @if (expandedRows.includes(invoice._id)) { Hide
                                Payments } @else { Show Payments }
                              </button>
                            </li>
                            }
                            <li>
                              <button
                                (click)="previewInvoice(invoice._id)"
                                type="button"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  class="h-4 w-4"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke="currentColor"
                                >
                                  <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                                  />
                                  <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                                  />
                                </svg>
                                Preview Invoice
                              </button>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </td>
                  </tr>
                  @if (expandedRows.includes(invoice._id)) {
                  <tr>
                    <td colspan="6" class="bg-base-200/50">
                      <div class="p-4">
                        <h4
                          class="font-semibold text-base mb-3 flex items-center gap-2"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="h-5 w-5"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"
                            />
                          </svg>
                          Payment History
                        </h4>
                        <div class="overflow-x-auto max-h-96">
                          <table
                            class="daisy-table daisy-table-zebra w-full bg-base-100"
                          >
                            <thead>
                              <tr>
                                <th>Paid On</th>
                                <th>Amount</th>
                                <th>Status</th>
                                <th>Attachments</th>
                              </tr>
                            </thead>
                            <tbody>
                              @for (payment of invoice.payments; track payment)
                              {
                              <tr>
                                <td>
                                  {{ payment.initiatedOn | date: 'MMM d, y' }}
                                </td>
                                <td class="font-medium">
                                  {{ payment.amount }}
                                </td>
                                <td>
                                  <span
                                    class="daisy-badge"
                                    [class.daisy-badge-success]="
                                      payment.isApproved
                                    "
                                    [class.daisy-badge-warning]="
                                      !payment.isApproved
                                    "
                                  >
                                    @if (payment.isApproved) { APPROVED } @else
                                    { PROCESSING }
                                  </span>
                                </td>
                                <td>
                                  @if (payment.bankData?.slip) {
                                  <button
                                    class="daisy-btn daisy-btn-sm daisy-btn-outline gap-2"
                                    (click)="
                                      downloadFile(
                                        payment.bankData?.slip?.path,
                                        payment.bankData?.slip?.name
                                      )
                                    "
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      class="h-4 w-4"
                                      fill="none"
                                      viewBox="0 0 24 24"
                                      stroke="currentColor"
                                    >
                                      <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                                      />
                                    </svg>
                                    Download
                                  </button>
                                  } @else {
                                  <span class="text-base-content/60"
                                    >No attachment</span
                                  >
                                  }
                                </td>
                              </tr>
                              }
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </td>
                  </tr>
                  } }
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
